import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { LOCAL_DEV } from '../GlobalStateContainer/actions'


function LocatePath(child, path) {
    if (child.PageLinkUrl.toLowerCase().includes(path.toLowerCase())) 
        return true;
    
    if (child.Children.length) 
        return child.Children.filter((subChild) => LocatePath(subChild, path)).length != 0;

    return false;
}

function RemoveResourceIdFromPath(path) {
    let pathParts = path.split('/'),
        lastPart = pathParts[pathParts.length - 1],
        endsWithId = Boolean(lastPart.match(/^(\d+)$/g));

    // Check to see if last portion of the path is for a specific resource (i.e. is an id)
    if (pathParts.length > 1 && endsWithId) {
        path = path.substring(0, path.length - lastPart.length - 1);
    }

    return path;
}

// A wrapper for <Route> that redirects to the login screen if you're not yet authenticated.
const SecureRoute = props => {
    const { component, location, user, isActive, menu } = props;
    var path = RemoveResourceIdFromPath(location.pathname);
    var pathFound = menu.some((mnu) => LocatePath(mnu, path));

    if (LOCAL_DEV) return <Route component={component} />

    if (pathFound == 0)
        return <Redirect to={{ pathname: "/Login", state: { from: location } }} />;
    else
        return user && isActive 
            ? <Route component={component} />
            : <Redirect to={{ pathname: "/Login", state: { from: location } }} />;
}

const mapStateToProps = state => ({
    user: state.oidc.user,
    isActive: state.userManager.isActive
});

export default connect(mapStateToProps)(SecureRoute)